/* import __COLOCATED_TEMPLATE__ from './private-message-glyph.hbs'; */
import Component from "@ember/component";

export default Component.extend({
  tagName: null,
  href: null,
  title: null,
  ariaLabel: null,
  shouldShow: null,
});
